import React from 'react';
import { track } from '../lib/telemetry';

/**
 * Last line of defense: ANY render crash shows what broke and offers a way
 * back, instead of React unmounting to a blank page. CI data is generated
 * from real-world failure text — the one place nulls and odd shapes are
 * guaranteed to show up eventually.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[dashboard] render crash:', error, info?.componentStack);
    // MCIP-28: a screen crash is exactly the event self-telemetry exists for.
    track('error_boundary', error?.message || String(error), {
      stack: error?.stack?.split('\n').slice(0, 5).join('\n') || null,
      component_stack: info?.componentStack?.split('\n').slice(0, 5).join('\n') || null,
    });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <main className="page">
        <section className="card empty">
          <h2 className="card__title">Something broke while rendering</h2>
          <p className="card__subtitle">
            The data behind this view hit a rendering bug — the fetch itself
            worked. This is on us, not your network.
          </p>
          <p className="card__subtitle" style={{ marginTop: 8 }}>
            <code>{String(this.state.error?.message || this.state.error)}</code>
          </p>
          <p style={{ marginTop: 12 }}>
            <button
              type="button"
              className="ghost-btn"
              onClick={() => {
                // Drop the deep-link params that may reference the crashing
                // record, then reload clean.
                const url = new URL(window.location.href);
                url.searchParams.delete('cluster');
                url.searchParams.delete('run');
                window.location.href = url.toString();
              }}
            >
              Reload the dashboard
            </button>
          </p>
        </section>
      </main>
    );
  }
}
